import { useEffect, useRef } from "react";

const TestimonialsCarousel = ({ testimonials }) => {
  const scrollRef = useRef(null);

  useEffect(() => {
    const container = scrollRef.current;
    const scrollSpeed = 1;

    let scrollAmount = 0;

    const scroll = () => {
      if (container) {
        container.scrollLeft += scrollSpeed;
        scrollAmount += scrollSpeed;

        // Reset to start for infinite scroll effect
        if (scrollAmount >= container.scrollWidth / 2) {
          scrollAmount = 0;
          container.scrollLeft = 0;
        }
      }
    };

    const intervalId = setInterval(scroll, 20); // Adjust speed here

    return () => clearInterval(intervalId);
  }, []);

  return (
    <section className="py-5">
      <div className="container">
        <div
          ref={scrollRef}
          className="testimonial-scroll-wrapper"
          style={{
            overflow: "hidden",
            whiteSpace: "nowrap",
            display: "flex",
            width: "100%",
            maxWidth: "100%",
            position: "relative",
          }}
        >
          {[...testimonials].map((testimonial, index) => {
            console.log(testimonial);
            return (
              <div
                style={{
                  flex: "0 0 350px",
                  margin: "0 12px",
                  background: "#fff",
                  border: "1px solid #e2e8f0",
                  borderRadius: "12px",
                  padding: "24px",
                  display: "inline-block",
                  whiteSpace: "normal",
                  padding: "24px",
                  display: "inline-block",
                }}
              >
                <p className="mb-3 fst-italic flex-wrap">
                  "{testimonial.content}"
                </p>
                <div className="d-flex align-items-center">
                  <div
                    className="testimonial-avatar me-3"
                    style={{
                      width: "50px",
                      height: "50px",
                      background: "#e2e8f0",
                      borderRadius: "50%",
                    }}
                  >
                    <img
                      src={testimonial.avatar}
                      alt="avatar"
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: "50%",
                      }}
                    />
                  </div>

                  <div>
                    <h6 className="mb-0">{testimonial.name}</h6>
                    <small className="text-muted">{testimonial.role}</small>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsCarousel;
